
import {defineComponent, PropType} from "vue";
import {ErrorLevelType} from "@/components/molecules/ErrorMessage";

export default defineComponent({
  name: "ErrorIcon",
  props: {
    level: {
      type: String as PropType<ErrorLevelType>,
      default: ''
    },
    small: {
      type: Boolean,
      default: false
    },
    dark: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    _icon(): string {
      switch(this.level) {
        case 'error':  return 'el-icon-warning';
        case 'warn':   return 'mdi-alert';
        case 'info':   return 'mdi-information-outline';
        case 'good':   return 'mdi-check-bold';
        default:       return 'mdi-check';
      }
    },
    _iconColor(): string {
      switch(this.level) {
        case 'error':   return 'red';
        case 'warn':    return 'orange';
        case 'info':    return this.dark ? 'white' : 'blue';
        case 'good':    return 'green';
        default:        return 'transparent';
      }
    }
  }
});
